import { html } from 'lit';

export const iconX = html`
  <svg
    width="21"
    height="21"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="2.5"
    aria-hidden="true"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
`;
